import React from 'react';
import { quote } from '../mock/data';

const Quote = () => (
  <section className="relative bg-white py-28 md:py-40">
    <div className="max-frame container-px">
      <blockquote className="reveal max-w-[1100px] mx-auto text-center">
        <p className="font-display uppercase font-tight text-[clamp(1.7rem,4.2vw,3.4rem)] leading-[1.05] text-[var(--ink)]">
          “{quote.text}”
        </p>
        <footer className="mt-10 flex items-center justify-center gap-3 text-sm uppercase tracking-[0.14em]">
          <span className="text-[var(--ink)]">{quote.author}</span>
          <span className="h-1 w-1 rounded-full bg-[var(--accent)]" />
          <span className="text-[var(--muted)]">{quote.role}</span>
        </footer>
      </blockquote>
    </div>
  </section>
);

export default Quote;
